module.exports = __webpack_public_path__ + "static/colorant-case-study-19d1e5913c012f4d96684c8c0b30853f.webp";